<template>
    <v-img contain height="22vh"
           class="ma-auto"
           max-width="300" width="75%"
           src="~@/assets/custom/images/login-logo.png"/>
</template>

<script>
export default {
  name: 'LogoNoText'
}
</script>
